import { config } from '@/config/config';
import { useDevice } from '@/hooks/use-device';
import { fitBoundsToPlaces, fitBoundsToRegion, setViewToRegion } from '@/utils/map';
import { getMapRegionFromSearch } from '@/utils/map-region';
import { useMap } from '@vis.gl/react-google-maps';
import { useEffect, useRef } from 'react';
import { useFiltersContext } from '../context/filters';
import { hasFilters } from '../utils/filters';
import { usePlaces } from './use-places';

export function useBounds() {
  const map = useMap();
  const places = usePlaces();
  const { isMobile } = useDevice();
  const { filters } = useFiltersContext();
  const initialRegionRef = useRef(getMapRegionFromSearch());
  const hasAppliedInitialRegionRef = useRef(false);
  const initialRegion = initialRegionRef.current;
  const hasActiveFilters = hasFilters(filters);

  useEffect(() => {
    if (!map) {
      return;
    }

    if (initialRegion) {
      if (!hasAppliedInitialRegionRef.current) {
        fitBoundsToRegion(map, initialRegion);
        hasAppliedInitialRegionRef.current = true;
      }

      return;
    }

    if (hasAppliedInitialRegionRef.current && !hasActiveFilters) {
      return;
    }

    if (config.initializeBounds && isMobile && !hasActiveFilters) {
      setViewToRegion(map);
      return;
    }

    fitBoundsToPlaces(map, places);
  }, [map, places, isMobile, hasActiveFilters, initialRegion]);
}
